import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

// packages
import parse from "html-react-parser";
import MathJax from "react-mathjax-preview";

// components
import PageHeader from "components/BreadCrumb";
import EntryFeedBackField from "components/EntryFeedBackField";

// hooks
import {
  useCompetionGetMCQ,
  useGetCompetitionMCQSList,
  useGetMCQ,
  useGetMCQS,
  useReviewMCQS,
} from "hooks/api/subject";

// context
import { useAuthContext } from "context/auth.context";

//
import { IMAGE_URL, dataReviewUser } from "constant";

const MCQDetail = () => {
  const { id } = useParams();
  const { user } = useAuthContext();
  const history = useHistory();
  const [state, setState] = useState({});
  const [rows, setRows] = useState([]);
  
  const { data: mcqs } = useGetCompetitionMCQSList();
  const { data: mcq, refetch } = useCompetionGetMCQ(id);
console.log("mcq detail",mcq)
  const reviewMCQ = useReviewMCQS();

  useEffect(() => {
    if (mcqs?.data) {
      setRows(mcqs?.data);
    }
  }, [mcqs]);

  const getCurrentMCQIndex = () => {
    return rows.findIndex((mcq) => mcq.id == id);
  };

  const navigateToMCQ = (newIndex) => {
    if (newIndex >= 0 && newIndex < rows.length) {
      const newMCQId = rows[newIndex].id;
      history.push(`/competion-mcqs-detail/${newMCQId}`);
    }
  };

  const onNext = () => {
    const currentIndex = getCurrentMCQIndex();
    if (currentIndex !== -1 && currentIndex < rows.length - 1) {
      navigateToMCQ(currentIndex + 1);
    }
  };

  const onPrevious = () => {
    const currentIndex = getCurrentMCQIndex();
    if (currentIndex !== -1 && currentIndex > 0) {
      navigateToMCQ(currentIndex - 1);
    }
  };

  const onSave = async () => {
    const body = { ...state };
    await reviewMCQ.mutateAsync({ id, body });
    refetch();
  };

  useEffect(() => {
    if (mcq?.data) {
      setState({
        status: mcq?.data?.status,
        feedback: mcq?.data?.feedback || "",
      });
    }
  }, [mcq]);

  const mcqData = mcq?.data;
  const rightOption = mcqData?.option_answer;
  const isMath = ["5", "12"].includes(`${mcqData?.subject_id}`);

  if (!mcqData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container-fluid">
      <PageHeader
        Breadcrumb={[{ name: "MCQS", navigate: "/competion-mcqs" }, { name: "Detail" }]}
      />
      <div className="card">
        <div className="header">
          <h2>MCQ Detail</h2>
        </div>

        <div className="body table-responsive">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th scope="row">Board:</th>
                <td>{mcqData.board_name}</td>
              </tr>
              <tr>
                <th scope="row">Subject:</th>
                <td>{mcqData.subject_name}</td>
              </tr>
              <tr>
                <th scope="row">Class:</th>
                <td>{mcqData.class_name}</td>
              </tr>
              <tr>
                <th scope="row">Chapter Name:</th>
                <td>{mcqData.chapter_name}</td>
              </tr>
              <tr>
                <th scope="row">Topic Name:</th>
                <td>{mcqData.topic_name}</td>
              </tr>
              <tr>
                <th scope="row">MCQ:</th>
                <td>
                  {isMath ? (
                    <MathJax math={mcqData.description} />
                  ) : (
                    parse(`${mcqData.description}`)
                  )}
                  {!!mcqData?.file && mcqData?.file !== "" && (
                    <MCQImage image={mcqData.file} />
                  )}
                </td>
              </tr>
              <tr
                style={{
                  backgroundColor: rightOption === "opt_a" ? "lightGreen" : undefined,
                }}
              >
                <th scope="row">Option A:</th>
                <td>
                  {isMath ? (
                    <MathJax math={mcqData?.opt_a} />
                  ) : (
                    parse(`${mcqData?.opt_a}`)
                  )}
                  {mcqData?.opt_a_file && mcqData?.opt_a_file !== "" && (
                    <MCQImage image={mcqData?.opt_a_file} />
                  )}
                </td>
              </tr>
              <tr
                style={{
                  backgroundColor: rightOption === "opt_b" ? "lightGreen" : undefined,
                }}
              >
                <th scope="row">Option B:</th>
                <td>
                  {isMath ? (
                    <MathJax math={mcqData?.opt_b} />
                  ) : (
                    parse(`${mcqData?.opt_b}`)
                  )}
                  {mcqData?.opt_b_file && mcqData?.opt_b_file !== "" && (
                    <MCQImage image={mcqData?.opt_b_file} />
                  )}
                </td>
              </tr>
              <tr
                style={{
                  backgroundColor: rightOption === "opt_c" ? "lightGreen" : undefined,
                }}
              >
                <th scope="row">Option C:</th>
                <td>
                  {isMath ? (
                    <MathJax math={mcqData?.opt_c} />
                  ) : (
                    parse(`${mcqData?.opt_c}`)
                  )}
                  {mcqData?.opt_c_file && mcqData?.opt_c_file !== "" && (
                    <MCQImage image={mcqData?.opt_c_file} />
                  )}
                </td>
              </tr>
              <tr
                style={{
                  backgroundColor: rightOption === "opt_d" ? "lightGreen" : undefined,
                }}
              >
                <th scope="row">Option D:</th>
                <td>
                  {isMath ? (
                    <MathJax math={mcqData?.opt_d} />
                  ) : (
                    parse(`${mcqData?.opt_d}`)
                  )}
                  {mcqData?.opt_d_file && mcqData?.opt_d_file !== "" && (
                    <MCQImage image={mcqData?.opt_d_file} />
                  )}
                </td>
              </tr>
              <tr>
                <th scope="row">Status:</th>
                <td>{mcqData.review_status}</td>
              </tr>
              <tr>
                <th scope="row">Feedback:</th>
                <td>{mcqData.feedback}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="body">
          <button
            type="submit"
            className="btn btn-success ml-auto"
            onClick={onPrevious}
            disabled={getCurrentMCQIndex() <= 0}
          >
            Previous
          </button>
          <button
            type="submit"
            className="btn btn-success mx-3"
            onClick={onNext}
            disabled={getCurrentMCQIndex() >= rows.length - 1}
          >
            Next
          </button>
        </div>

        {user.rolename.toLowerCase() === dataReviewUser && (
          <EntryFeedBackField
            state={state}
            setState={setState}
            onSave={onSave}
          />
        )}
      </div>
    </div>
  );
};

export default MCQDetail;

const MCQImage = ({ image }) => {
  return (
    <img
      src={`${IMAGE_URL}/${image}`}
      alt="image"
      style={{ maxWidth: "200px", width: "150px" }}
    />
  );
};
